<template>
    <h-tab-panels>
        <slot></slot>
    </h-tab-panels>
</template>
